import script from "./bookDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./bookDetail.vue?vue&type=script&lang=ts&setup=true"

import "./bookDetail.vue?vue&type=style&index=0&id=87efc822&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87efc822"]])

export default __exports__